import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
  },
  saveButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'white',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '39%',
    marginRight: '3%',
    backgroundColor: '#DF0C36',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: '#DF0C36',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 5px white',
    },
  },
  cancelButton: {
    backgroundColor: 'white',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#DF0C36',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '36%',
    marginRight: '3%',
    boxShadow: '0px 15px 20px rgb(217 224 221 / 40%)',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  button: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '20px',
    color: '#DF0C36',
    marginBottom: 7,
  },
  accordion: {
    margin: '0px !important',
    borderTop: '2px solid #DF0C36',
  },
  heading: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
    color: '#666666',
  },
  description: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '22px 48px',
    position: 'static',
    width: '80%',
    left: '61px',
    top: '70px',
    background: '#FAFAFA',
    borderRadius: '2px',
    flex: 'none',
    order: 1,
    flexGrow: 0,
    margin: '0px auto',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
  },
  asterisk: {
    color: '#DF0C36',
  },
  expandIcon: {
    color: '#DF0C36',
  },
  container: {
    margin: '32px auto',
    width: '80%',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '20px',
    color: '#666666',
  },
  gridMargin: {
    margin: '15px !important',
  },
  input: {
    height: 40,
    paddingRight: 0,
    width: 153,
  },
  datePicker: {
    width: 170,
    marginTop: 0,
  },
  formControl: {
    width: 160,
  },
  select: {
    minWidth: 160,
    height: 40,
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '27px',
    color: '#403e3e',
  },
  dropdownStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 14,
    lineHeight: '27px',
    color: '#403e3e',
  },
}));
